var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{attrs:{"color":_vm.color,"disabled":_vm.delayLoading},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.delayLoading)?_c('c-spinner',{attrs:{"color":"white","size":"sm"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }